import {
	ADD_TO_CART,
	REMOVE_ITEM,
	SUB_QUANTITY,
	SPECIAL_REQUEST,
	ADD_QUANTITY,
	DISCOUNT,
	REMOVE_DISCOUNT,
	SHOW_CART,TIP,
	CLEAR_CART,
	ADD_SOLD_QUANTITY,
	UPDATE_ITEM_SPECIAL_REQUEST,
} from '../action-types/cart-actions';
import { CART_DATA } from '../../utils/constant';

export const addToCart = (item, quantity = 1) => {
	// Add default order status flags to the item payload
	const mappedItem = {
		...item,
		item_confirmed: true,
		is_kot_printed: false,
		is_void: false,
		isVoid: false,
		is_refund: false,
		is_prepared: false
	};

	return {
		type: ADD_TO_CART,
		item: mappedItem,
		quantity,
	};
};
//remove item action
export const removeItem = (item) => {
	return {
		type: REMOVE_ITEM,
		item,
	};
};
//subtract qt action
export const subtractQuantity = (item) => {
	return {
		type: SUB_QUANTITY,
		item,
	};
};
//add qt action
export const addQuantity = (item) => {
	return {
		type: ADD_QUANTITY,
		item,
	};
};


export const addTip = (tip) => {
	return {
		type: TIP,
		tip,
	};
};

export const addDiscount = (value, termStyle) => {
	return {
		type: DISCOUNT,
		value,
		termStyle,
	};
};

export const removeDiscount = (value) => {
	return {
		type: REMOVE_DISCOUNT,
		value,
	};
};

export const specialRequest=(splReq)=>{
    return{
        type: SPECIAL_REQUEST,
        splReq
    };
};

export const updateItemSpecialRequest = (itemUniqueId, specialRequest) => {
	return {
		type: UPDATE_ITEM_SPECIAL_REQUEST,
		itemUniqueId,
		specialRequest,
	};
};

export const showCart = () => {
	return {
		type: SHOW_CART,
	};
};

export const clearCart = () => {
	return {
		type: CLEAR_CART,
	};
};

export const addSoldQuantity = (item) => {
	return {
		type: ADD_SOLD_QUANTITY,
		item,
	};
};
